// SEO metadata for each page
export const seoData = {
  home: {
    title: 'Custom Cakes in Hoofddorp & Amsterdam | The Bake Nook',
    description: 'Fresh cream birthday cakes, baked to order in Hoofddorp. Indian fusion flavours like Rasmalai and Gulab Jamun, with eggless options for most flavours.',
    keywords: 'Indian fusion cakes, authentic Indian cakes Amsterdam, custom fusion cakes, rasmalai cake, gulab jamun cake, rabri jalebi cake, fresh cream cakes, custom birthday cakes, designer cakes, wedding cakes, celebration cakes, vanilla cake, chocolate cake, black forest cake, white forest cake, tiramisu cake, honey cake medovik, fresh fruit cakes, strawberry cake, blueberry cake, mango cake, pineapple cake, eggless cakes, Hoofddorp bakery, Amsterdam Indian bakery, Netherlands fusion bakery, cake Amsterdam, cake Hoofddorp, bakery Amsterdam, eggless cake Amsterdam, custom cake Amsterdam, birthday cake Amsterdam, wedding cake Amsterdam',
    url: '/',
    image: '/images/og-cover.jpg',
  },
  about: {
    title: 'About Us - The Baker Behind The Bake Nook',
    description: 'Meet the baker behind The Bake Nook in Hoofddorp. From a home kitchen to fresh cream and Indian fusion cakes for families across North Holland.',
    keywords: 'about the bakenook, Indian fusion bakery story, authentic Indian cakes, handcrafted fusion cakes, custom cake designer, fusion cake specialist, birthday cake expert, Hoofddorp bakery, Amsterdam Indian bakery, homemade cakes, fresh cream cakes',
    url: '/about',
    image: '/images/og-cover.jpg',
  },
  gallery: {
    title: 'Cake Gallery: Birthday & Wedding Cakes | The Bake Nook',
    description: 'Photos of our custom birthday, wedding and Indian fusion cakes. Get ideas for your celebration, then design your own cake in Hoofddorp.',
    keywords: 'cake gallery, custom cake designs, designer cakes, bakery portfolio, cake inspiration, wedding cakes, birthday cake designs, fusion cake gallery, Indian fusion cakes, celebration cake ideas, custom cake photos, cake decoration ideas, fresh fruit cakes, chocolate cakes, special occasion cakes',
    url: '/gallery',
    image: '/images/og-cover.jpg',
  },
  menu: {
    title: 'Rasmalai, Gulab Jamun & Fresh Cream Cakes | Bake Nook',
    description: 'See all our flavours: Rasmalai, Gulab Jamun, Rabri Jalebi, chocolate, fruit and more. All fresh cream, most can be eggless. Order online in Hoofddorp.',
    keywords: 'cake menu, custom cake flavors, bakery menu, cake prices, order cake, rasmalai cake, gulab jamun cake, rabri jalebi cake, Indian fusion cakes, vanilla cake, chocolate cake, black forest cake, white forest cake, eggless cakes, pineapple cake, mixed fruit cake, mango cake, blueberry cake, strawberry cake, fresh fruit cakes, tiramisu cake, honey cake, medovik, chocolate mousse cake, designer birthday cakes, wedding cake menu, celebration cakes, premium cakes',
    url: '/menu',
    image: '/images/og-cover.jpg',
  },
  cupcakes: {
    title: 'Cupcakes Bestellen in Hoofddorp | The Bake Nook',
    description: 'Order fresh cupcakes in Hoofddorp: vanilla, chocolate, blueberry and carrot, in mini, small and standard sizes. Custom designs, free pickup in Hoofddorp.',
    keywords: 'cupcakes Amsterdam, cupcakes Hoofddorp, custom cupcakes, mini cupcakes, vanilla cupcakes, chocolate cupcakes, blueberry cupcakes, carrot cupcakes, cupcake boxes, eggless cupcakes, gourmet cupcakes, celebration cupcakes, custom cupcake designs',
    url: '/cupcakes',
    image: '/images/og-cover.jpg',
  },
  cakeBuilder: {
    title: 'Design Your Own Birthday Cake Online | The Bake Nook',
    description: 'Build your custom birthday cake: pick the size, flavour, cream and decoration, see the price, and order online. Made fresh in Hoofddorp.',
    keywords: 'custom cake builder, design cake online, cake customization, order custom cake, cake configurator, designer birthday cake, custom wedding cake, build your own cake, personalized cakes, fusion cake builder, Indian fusion cakes online, custom celebration cakes, bespoke cakes, made-to-order cakes, custom cake design tool',
    url: '/cake-builder',
    image: '/images/og-cover.jpg',
    type: 'website',
  },
  contact: {
    title: 'Contact Us & Order a Cake in Hoofddorp | The Bake Nook',
    description: 'Message us about a custom cake order or a special request. We bake every cake fresh to order in Hoofddorp.',
    keywords: 'contact bakery, order custom cake, bakery inquiries, cake consultation, custom birthday cake order, designer cake consultation, fusion cake orders, wedding cake inquiry, Hoofddorp bakery contact, Netherlands bakery, custom cake quote, cake order form',
    url: '/contact',
    image: '/images/og-cover.jpg',
  },
  faq: {
    title: 'Eggless Cakes, Prices & Ordering FAQ | The Bake Nook',
    description: 'Answers about eggless cakes, Indian fusion flavours, prices and pickup in Hoofddorp. Everything you need to know before you order.',
    keywords: 'cake FAQ, bakery questions, how to order custom cake, what is rasmalai cake, eggless cakes, Indian fusion cake questions, cake sizes guide, cake pricing, custom cake design, Hoofddorp bakery FAQ, halal cakes, vegetarian cakes, cake customization',
    url: '/faq',
    image: '/images/og-cover.jpg',
  },
  blog: {
    title: 'Cake Blog: Ideas & Indian Fusion Guides | The Bake Nook',
    description: 'Birthday cake ideas, guides to Indian fusion flavours like Rasmalai, and tips for ordering the right cake. From The Bake Nook kitchen in Hoofddorp.',
    keywords: 'cake blog, baking tips, Indian fusion cake recipes, celebration cake ideas, rasmalai cake guide, birthday cake ideas Hoofddorp, cake inspiration Amsterdam, cake blog Hoofddorp, bakery blog Netherlands, custom cake tips, eggless cake recipes, cake ordering guide, wedding cake blog, festival cake ideas, cake decoration inspiration, gulab jamun cake recipe, Hoofddorp bakery news',
    url: '/blog',
    image: '/images/og-cover.jpg',
  },
  taartBestellen: {
    title: 'Taart bestellen in Hoofddorp | The Bake Nook',
    description: 'Taart op maat bestellen in Hoofddorp: verse slagroomtaarten, Indiase smaken zoals Rasmalai, taart zonder ei of met foto. Gratis afhalen.',
    keywords: 'taart bestellen hoofddorp, taart hoofddorp, taarten hoofddorp, taart op maat, slagroomtaart bestellen, taart zonder ei, taart met foto bestellen, verjaardagstaart bestellen, taart nieuw-vennep',
    url: '/taart-bestellen-hoofddorp',
    image: '/images/og-cover.jpg',
    lang: 'nl',
  },
  privacy: {
    title: 'Privacy Policy | The BakeNook',
    description: 'How The Bake Nook collects, uses, and stores your data when you order a cake, contact us, or chat with us on WhatsApp.',
    keywords: 'privacy policy, the bakenook privacy, data protection, GDPR',
    url: '/privacy',
    image: '/images/og-cover.jpg',
  },
};

// Structured Data for LocalBusiness (used on homepage and contact page)
export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'Bakery',
  name: 'The Bake Nook',
  description: 'The Bake Nook is a premium bakery based in Hoofddorp, serving Amsterdam, Haarlem, and all of North Holland. We specialize in 100% fresh cream cakes, custom birthday cakes, and celebration cakes made to order with high-quality ingredients. Our signature Indian fusion cakes bring beloved desi flavours to life — Rasmalai cake, Gulab Jamun cake, Jalebi cake, Kaju Katli cake, and Rasgulla cake — blending traditional Indian sweet tastes with modern cake designs. Eggless options available for every flavor. Perfect for birthdays, weddings, baby showers, Diwali, Eid, Raksha Bandhan, and all cultural celebrations.',
  url: 'https://bakenook.nl',
  logo: 'https://bakenook.nl/images/logo/bakenook-logo.jpeg',
  image: 'https://bakenook.nl/images/og-cover.jpg',
  telephone: '+31622998661',
  email: 'hello@bakenook.nl',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Graan Voor Visch',
    addressLocality: 'Hoofddorp',
    addressRegion: 'North Holland',
    postalCode: '2132ED',
    addressCountry: 'NL',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 52.3026,
    longitude: 4.6897,
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '09:00',
      closes: '18:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Sunday',
      opens: '10:00',
      closes: '16:00',
    },
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    bestRating: '5',
    ratingCount: '3000',
  },
  priceRange: '€€',
  servesCuisine: ['Indian Fusion Cakes', 'Fresh Cream Cakes', 'Custom Celebration Cakes'],
  menu: 'https://bakenook.nl/menu',
  hasMenu: {
    '@type': 'Menu',
    url: 'https://bakenook.nl/menu',
    hasMenuSection: [
      {
        '@type': 'MenuSection',
        name: 'Indian Fusion Cakes',
        description: 'Rasmalai cake, Gulab Jamun cake, Jalebi cake, Kaju Katli cake, Rasgulla cake',
      },
      {
        '@type': 'MenuSection',
        name: 'Fresh Cream Cakes',
        description: 'Vanilla, Chocolate, Black Forest, White Forest, Fresh Fruit cakes',
      },
      {
        '@type': 'MenuSection',
        name: 'Custom Celebration Cakes',
        description: 'Birthday cakes, Wedding cakes, Baby shower cakes, Number cakes, Themed cakes',
      },
    ],
  },
  acceptsReservations: 'True',
  areaServed: [
    { '@type': 'City', name: 'Hoofddorp' },
    { '@type': 'City', name: 'Amsterdam' },
    { '@type': 'City', name: 'Haarlem' },
    { '@type': 'AdministrativeArea', name: 'North Holland' },
  ],
  paymentAccepted: ['Cash', 'Credit Card', 'iDEAL'],
  knowsAbout: [
    'Rasmalai Cake', 'Gulab Jamun Cake', 'Jalebi Cake', 'Kaju Katli Cake',
    'Rasgulla Cake', 'Indian Fusion Cakes', 'Fresh Cream Cakes',
    'Custom Birthday Cakes', 'Wedding Cakes', 'Eggless Cakes',
  ],
  sameAs: [
    'https://instagram.com/the_bake_nook',
    'https://facebook.com/the_bake_nook',
  ],
};

// Breadcrumb structured data generator
export const generateBreadcrumbSchema = (breadcrumbs) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: `https://bakenook.nl${crumb.url}`,
    })),
  };
};

// Product schema for cakes (can be used on menu page)
export const generateProductSchema = (product) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: product.description,
    image: product.image,
    brand: {
      '@type': 'Brand',
      name: 'The BakeNook',
    },
    offers: {
      '@type': 'Offer',
      priceCurrency: 'EUR',
      price: product.price,
      availability: 'https://schema.org/InStock',
      url: `https://bakenook.nl/menu`,
    },
  };
};
